module.exports = __webpack_public_path__ + "img/CMBC-FPD-detail.00abefa6.png";